/**
 * @file Defines Text14 style
 */

import styled, { css } from "styled-components";

const Text14 = styled.div`
  font-family: ${({ font }) => font ? font : 'SFMedium'};
  font-size: 14px;
  line-height:${({ height }) => height ? 24 : 16}px;
  text-align: ${({ align }) => align ? align : 'left'};
  color: ${({ color }) => color ? color : '#373737'};
  b{
    font-weight:bold;
  }
  ${({ maxWidth }) => maxWidth && css`
    max-width: ${maxWidth};
  `}
`;

export default Text14;